var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProcess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3000 512",
    style: {
      enableBackground: "new 0 0 3000 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1500,512c141.4,0,256-114.6,256-256S1641.4,0,1500,0s-256,114.6-256,256S1358.6,512,1500,512z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256,512c141.4,0,256-114.6,256-256S397.4,0,256,0S0,114.6,0,256S114.6,512,256,512z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2744,512c141.4,0,256-114.6,256-256S2885.4,0,2744,0s-256,114.6-256,256S2602.6,512,2744,512z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M279,112.9c0-8.5-4.7-16.3-12.2-20.3c-7.5-4-16.6-3.6-23.7,1.2l-69.1,46.1c-10.6,7.1-13.4,21.3-6.3,32 s21.4,13.5,32,6.4l33.3-22.2v210.4h-46.1c-12.7,0-23,10.3-23,23c0,12.7,10.3,23,23,23H256h69.1c12.7,0,23-10.3,23-23 c0-12.7-10.3-23-23-23H279V112.9z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1487.7,135c-15.5,0-30.4,6.1-41.3,17.1l-22.2,22.2c-9,9-23.6,9-32.6,0s-9-23.6,0-32.6l22.2-22.2 c19.7-19.6,46.2-30.6,73.9-30.6c57.7,0,104.5,46.8,104.5,104.5c0,27.7-11,54.3-30.6,73.9l-98.1,98.1h128.7c12.7,0,23,10.3,23,23 s-10.3,23-23,23h-184.3c-9.3,0-17.7-5.6-21.3-14.3c-3.6-8.6-1.6-18.5,5-25.1L1529,234.7c10.9-10.9,17.1-25.8,17.1-41.3 C1546.1,161.2,1520,135,1487.7,135z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2628.8,112c0-12.7,10.3-23,23-23h172.8c9.5,0,18,5.8,21.5,14.7s1.1,18.9-5.9,25.3l-94.5,86.7h15.6 c54.1,0,97.9,43.8,97.9,97.9s-43.8,97.9-97.9,97.9h-56.6c-30.5,0-58.5-17.3-72.1-44.6l-1.4-2.7c-5.7-11.4-1.1-25.2,10.3-30.9 c11.4-5.7,25.2-1.1,30.9,10.3l1.4,2.7c5.8,11.7,17.9,19.1,30.9,19.1h56.7c28.7,0,51.8-23.2,51.8-51.8c0-28.7-23.2-51.8-51.8-51.8 h-74.9c-9.5,0-18-5.8-21.5-14.7c-3.5-8.9-1.1-18.9,5.9-25.3l94.5-86.7h-113.5C2639.1,135,2628.8,124.7,2628.8,112z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M980.7,227.6c12.5,12.5,12.5,32.8,0,45.3l-160,160c-12.5,12.5-32.8,12.5-45.3,0s-12.5-32.8,0-45.3l137.4-137.4L775.5,112.8 c-12.5-12.5-12.5-32.8,0-45.3s32.8-12.5,45.3,0L980.7,227.6L980.7,227.6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2224.6,227.6c12.5,12.5,12.5,32.8,0,45.3l-160,160c-12.5,12.5-32.8,12.5-45.3,0s-12.5-32.8,0-45.3l137.4-137.4 l-137.3-137.4c-12.5-12.5-12.5-32.8,0-45.3s32.8-12.5,45.3,0l160,160L2224.6,227.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcess);
export default __webpack_public_path__ + "static/media/process.ae58814443a3009342aa6b5672da53de.svg";
export { ForwardRef as ReactComponent };